module.exports = __webpack_public_path__ + "img/visa.1114b987.png";